import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      mt: [10, 12],
      px: [8, 0],
      width: '100%',
    };

    this.heading = {
      fontSize: ['18px', 3],
      lineHeight: ['22px', '20px'],
      fontWeight: [400, 500],
      fontFamily: 'body',
      mb: 8,
    };

    this.button = {
      width: ['100%', 'auto'],
      minWidth: ['100%', '160px'],
      display: 'flex',
      fontSize: ['15px', '14px'],
    };
  })()
);
